import { createAction, props } from '@ngrx/store';

export const SET_ACTIVE_TENANT_DATA = createAction(
  '[Tenant] Set Active Tenant Data',
  props<{ actions: any[] }>()
); 